/*=========================================================================================
  File Name: moduleEmailState.js
  Description: Email Module State
  ----------------------------------------------------------------------------------------

==========================================================================================*/


export default {
  mailFolders:[],
  mails: [],
  mailSelected: [],
  mail_filter: null,
  // mailTags: [],
  meta: {
    unreadMails: {
      folder: {},
      label: {}
    },
    draftMails: []
  },
  mailSearchQuery: '',
  accountEmailSelect: '',
  folderSelect: ''
}
